import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ScannerContext } from "../store/ScannerContextProvider";
import { DialogContext } from "../store/DialogContextProvider";

export function useFileDropActions() {
  const navigate = useNavigate();
  const { isScanOn } = useContext(ScannerContext);
  const { handleFocusOnScanner } = useContext(ScannerContext);
  const { isDialogOpen, setIsDialogOpen } = useContext(DialogContext);

  function handleFileDropped() {
    if (!isScanOn) return;
    if (isDialogOpen) {
      setIsDialogOpen(false);
    }
    handleFocusOnScanner();
  }

  function handleFileDroppedNavigation(route: string) {
    navigate(route);
  }

  return {
    handleFileDropped,
    handleFileDroppedNavigation,
  };
}
